export function measures(state) {
  return state.measures
}

export function tyreCategories(state) {
  return state.tyreCategories
}
